import React from 'react';

import { RecursiveMenu } from '@uncinc/react-drupal-core';

import { useMegaMenuContext } from '../../../context/MegaMenuContext';
import MegaMenuTopMenuItemLinkElement from './ItemLinkElement';

import './style.scss';

const MegaMenuTopMenu: React.FC = () => {
  const { menuId, updateExpandedMenuItem } = useMegaMenuContext();

  return (
    <div className="MegaMenu__TopMenu">
      <div
        className="MegaMenu__TopMenu__overlay-closer MegaMenu__TopMenu__overlay-closer--left"
        onMouseEnter={() => updateExpandedMenuItem('')}
      />
      <RecursiveMenu
        menuId={menuId}
        maxLevel={1}
        onClickFunction={() => updateExpandedMenuItem('')}
        MenuItemLinkElement={MegaMenuTopMenuItemLinkElement}
      />
      <div
        className="MegaMenu__TopMenu__overlay-closer MegaMenu__TopMenu__overlay-closer--right"
        onMouseEnter={() => updateExpandedMenuItem('')}
      />
    </div>
  );
};

export default MegaMenuTopMenu;
